import { request } from "../utils/request.js"

export const supplier_addNew = (pojo, args) => request({
    url: 'supplier/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const supplier_update = (pojo, args) => request({
    url: 'supplier/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const supplier_findPageForManage = (pojo, args) => request({
    url: 'supplier/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const supplier_changeFrozenStatus = (id, args) => request({
    url: 'supplier/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const supplier_findById = (id, args) => request({
    url: 'supplier/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

// 分页查询 - 选择页面分页查询 默认按名称正序排列
export const supplier_findPageForSelect = (params, args) => request({
	url: 'supplier/findPageForSelect',
	method: 'POST',
	params: params,
	showLoading: true,
	showFailToast: true,
	...args
})


// WEBPACK FOOTER //
// ./src/api/supplier.js